<template>
  <layout-no-container
    container-class="margin-remove-vertical"
    :title="title"
    :sub-title="subTitle">
    <layout-dashboard-inner :nav-list="navList" :back-link="backLink">
      <slot></slot>
    </layout-dashboard-inner>
  </layout-no-container>
</template>

<script>
export default {
  props: {
    backButton: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
  setup() {
    const navList = [
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard" },
        label: "justopp.userDashboard.nav.dashboard",
      },
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard-profile" },
        label: "justopp.userDashboard.nav.personalProfile",
      },
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard-profile-company" },
        label: "justopp.userDashboard.nav.companyProfile",
      },
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard-chats" },
        label: "justopp.userDashboard.nav.chats",
      },
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard-orders" },
        label: "justopp.userDashboard.nav.orders",
      },
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard-bids" },
        label: "justopp.userDashboard.nav.bids",
      },
      {
        class: "requires-exact-active",
        to: { name: "user-dashboard-addresses" },
        label: "justopp.userDashboard.nav.addresses",
      },
    ];

    const link = {
      name: "user-dashboard",
    };

    return { navList, link };
  },
  computed: {
    backLink() {
      return this.backButton ? this.link : false;
    },
  },
};
</script>

<style></style>
